export function addIndexCPU(indices, axis, count) {
    const result = indices.copy();
    for (let i = axis; i < result.size; i += indices.shape[1]) {
        result.set(i, result.get(i) + count);
    }
    return result;
}
//# sourceMappingURL=cpu.js.map